<app-image
  [sources]="flagImageSources()"
  [defaultSrc]="flagImagePath()"
  [borderRadius]="ImageBorderRadiusEnum.ROUND"
></app-image>
